import Vue from 'vue'
import Router from 'vue-router'
import {SysManageRoutes} from './SysManageRoutes'
import {AccessControlRoutes} from './AccessControlRoutes'
import {ApplyBasicRoutes} from './ApplyBasicRoutes'
import {ConsumeRoutes} from './ConsumeRoutes'
import {PaymentRoutes} from './PaymentRoutes'
import {OrderRoutes} from './OrderRoutes'
import {ProgramRoutes} from './ProgramRoutes'
import {ErpRoutes} from './ErpRoutes'

Vue.use(Router)

export default new Router({
  base: '/smartPark/',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/pages/LoginPage')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/LoginPage')
    },
    {
      path: '/home',
      name: 'home',
      // component: () => import('@/pages/AccessControl/Home'),
      component: () => import('@/pages/Home'),
      children: [
        ...AccessControlRoutes,
        ...SysManageRoutes,
        ...ApplyBasicRoutes,
        ...ConsumeRoutes,
        ...PaymentRoutes,
        ...OrderRoutes,
        ...ProgramRoutes,
        ...ErpRoutes,
        {
          path: 'index',
          name: 'index',
          component: () => import('@/pages/homeBackground')
        }
      ]
    }, {
      path: '/reset',
      name: 'reset',
      component: () => import('@/pages/ResetPassWord')
    }, {
      path: '/platformlogin',
      name: 'platformlogin',
      component: () => import('@/pages/PlatformLoginPage')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js